/** Mobile width % for media when desktop has 4+ columns (capped). */
export const MOBILE_MEDIA_WIDTH_CAPPED = 40;
/** Mobile width % for media when desktop has 2-3 columns (no cap). */
export const MOBILE_MEDIA_WIDTH_FEW = 100;
/** Desktop sets-per-line threshold: >= this many columns → cap media on mobile. */
export const SETS_PER_LINE_THRESHOLD_CAPPED = 4;
/** Offset subtracted from capped mobile widths when combo maxWidth is "narrow". */
export const NARROW_MOBILE_MEDIA_OFFSET = 10;

/**
 * Returns the mobile width percentage for media inside an Array combo based on
 * desktop sets per line. Used to avoid small desktop images blowing up to 100% on mobile.
 * - 4+ sets per line → 40% (30% for narrow combo)
 * - 1-3 sets per line → 100% (no cap, unaffected by narrow)
 */
export const getMobileMediaWidthPercent = (
  setsPerLine: number,
  isNarrow = false,
): number => {
  if (setsPerLine < SETS_PER_LINE_THRESHOLD_CAPPED)
    return MOBILE_MEDIA_WIDTH_FEW;
  const offset = isNarrow ? NARROW_MOBILE_MEDIA_OFFSET : 0;
  return MOBILE_MEDIA_WIDTH_CAPPED - offset;
};
